"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var styles_1 = require("@mui/material/styles");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_1 = __importStar(require("react"));
var react_admin_1 = require("react-admin");
var Presentations_module_css_1 = __importDefault(require("./Presentations.module.css"));
var react_2 = require("react");
var react_i18next_1 = require("react-i18next");
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var RAStyles_1 = require("../common/ReactAdmin/RAStyles");
var inertia_react_1 = require("@inertiajs/inertia-react");
var react_dom_1 = require("react-dom");
var Pagination_1 = __importDefault(require("../common/ReactAdmin/Pagination"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var TextFieldWithTranslation_1 = __importDefault(require("../common/ReactAdmin/TextFieldWithTranslation"));
var types_1 = require("@/Types/types");
var EditableName_1 = __importDefault(require("../common/EditableName"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var ResourceAccessModal_1 = __importDefault(require("../common/ResourceAccessModal"));
var MeatballMenu_1 = __importDefault(require("../common/MeatballMenu"));
var types_2 = require("@/Types/types");
var AccessControl_1 = __importDefault(require("../common/AccessControl"));
var userPermissions_1 = require("@/Hooks/userPermissions");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var Popover_1 = __importDefault(require("@mui/material/Popover"));
var List_1 = __importDefault(require("@mui/material/List"));
var ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
var ListItemButton_1 = __importDefault(require("@mui/material/ListItemButton"));
var ResourceDeleteErrorModal_1 = __importDefault(require("../common/ResourceDeleteErrorModal"));
var imageErrorCache_1 = require("@/functions/imageErrorCache");
var SelectInputPresentationGroup = function (_a) {
    var groups = _a.groups, onGroupChange = _a.onGroupChange, onGroupsUpdated = _a.onGroupsUpdated, type = _a.type, permissions = _a.permissions;
    var record = (0, react_admin_1.useRecordContext)();
    var _b = (0, react_2.useState)(record.presentation_group_id), selectedGroupId = _b[0], setSelectedGroupId = _b[1];
    var _c = (0, react_2.useState)(function () {
        var group = groups.find(function (group) { return group.id === record.presentation_group_id; });
        return group ? group.name : "";
    }), groupName = _c[0], setGroupName = _c[1];
    var logger = q_play_core_1.logManager.getLogger();
    var hasPermission = (0, userPermissions_1.usePermissions)().hasPermission;
    var _d = (0, react_2.useState)(null), anchorEl = _d[0], setAnchorEl = _d[1];
    var allowedGroups = (0, react_1.useMemo)(function () {
        return groups.filter(function (group) {
            return hasPermission("resource-group-manager", group.id, "".concat(type.toLowerCase(), "Groups")) ||
                hasPermission("global-".concat(type.toLowerCase(), "s-manager"), undefined, "global");
        });
    }, [groups, type, hasPermission]);
    var onGroupNameSave = function (id, newName) { return __awaiter(void 0, void 0, void 0, function () {
        var trimmedNewName, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trimmedNewName = newName.trim();
                    if (!trimmedNewName || trimmedNewName === groupName) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ApiManager_1.default.updatePresentationGroupName(id, trimmedNewName, type)];
                case 2:
                    _a.sent();
                    onGroupsUpdated();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    logger.error("Failed to update presentation group name:", error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onChangeHandler = function (group, event) { return __awaiter(void 0, void 0, void 0, function () {
        var isAllowedGroup;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.stopPropagation();
                    isAllowedGroup = allowedGroups.some(function (g) { return g.id === group.id; });
                    if (!isAllowedGroup) return [3 /*break*/, 2];
                    setSelectedGroupId(group.id);
                    setGroupName(group.name);
                    return [4 /*yield*/, ApiManager_1.default.updatePresentationGroup(record, group.id)];
                case 1:
                    _a.sent();
                    if (onGroupChange)
                        onGroupChange(group.id, group.name);
                    return [3 /*break*/, 3];
                case 2:
                    logger.error("Selected group is not allowed");
                    _a.label = 3;
                case 3:
                    handleClose(event);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        var updatedGroup = allowedGroups.find(function (group) { return group.id === selectedGroupId; });
        if (updatedGroup) {
            setGroupName(updatedGroup.name);
        }
    }, [allowedGroups, selectedGroupId]);
    var handleIconClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function (event) {
        event.stopPropagation();
        setAnchorEl(null);
    };
    return (react_1.default.createElement(react_admin_1.Form, null,
        react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaSelectInputTheme },
            react_1.default.createElement("div", { style: { display: "flex", alignItems: "center", gap: "45px" } },
                react_1.default.createElement(EditableName_1.default, { id: selectedGroupId, name: groupName, onSave: onGroupNameSave, style: { flexGrow: 1, background: "#FFFFFF", fontSize: "14px" }, key: selectedGroupId, permissions: permissions, type: types_2.ResourceType[type] }),
                react_1.default.createElement(AccessControl_1.default, { resourceId: selectedGroupId, resourceType: "".concat(type.toLowerCase(), "Groups"), optionalPermissions: ["global-".concat(type.toLowerCase(), "s-manager"), "resource-group-manager"] },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faChevronDown, onClick: function (event) {
                            event.stopPropagation();
                            handleIconClick(event);
                        }, style: { cursor: "pointer" } }),
                    react_1.default.createElement(Popover_1.default, { open: Boolean(anchorEl), anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                        }, transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                        }, sx: {
                            borderRadius: "10px",
                            ".MuiPaper-root": {
                                borderRadius: "10px"
                            }
                        } },
                        react_1.default.createElement(List_1.default, { component: "nav", "aria-label": "presentation group selection", style: { fontFamily: "Geomanist", color: "var(--info-color)", overflow: "hidden", padding: "0" } }, allowedGroups.length > 0 && (allowedGroups.map(function (group) { return (react_1.default.createElement(ListItemButton_1.default, { key: group.id, onClick: function (event) {
                                event.stopPropagation();
                                onChangeHandler(group, event);
                            } },
                            react_1.default.createElement(ListItemText_1.default, { primary: group.name }))); })))))))));
};
var ColoredStatusField = function (_a) {
    var t = _a.t, label = _a.label;
    var record = (0, react_admin_1.useRecordContext)();
    return (react_1.default.createElement(TextFieldWithTranslation_1.default, { label: label, source: "state", sx: {
            backgroundColor: record.state === types_1.PresentationState.DRAFT ? "var(--warning-color)" : "var(--primary-color)",
            fontSize: "10px",
            fontFamily: "Geomanist-Bold",
        }, className: Presentations_module_css_1.default.presentation_status_list_container, t: t }));
};
var ImageFieldWithPlaceholder = react_1.default.memo(function (_a) {
    var source = _a.source;
    var record = (0, react_admin_1.useRecordContext)();
    var _b = (0, react_2.useState)(!imageErrorCache_1.failedImageUrls.has(record[source])), isLoading = _b[0], setIsLoading = _b[1];
    var _c = (0, react_2.useState)(imageErrorCache_1.failedImageUrls.has(record[source])), isError = _c[0], setIsError = _c[1];
    var src = record[source];
    var handleLoad = function () {
        setIsLoading(false);
    };
    var handleError = function () {
        setIsError(true);
        setIsLoading(false);
        imageErrorCache_1.failedImageUrls.add(src);
    };
    (0, react_1.useEffect)(function () {
        if (imageErrorCache_1.failedImageUrls.has(src)) {
            setIsError(true);
            setIsLoading(false);
        }
        else {
            setIsError(false);
            setIsLoading(true);
        }
    }, [src]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isLoading && !isError && react_1.default.createElement(q_play_components_1.Spinner, null),
        isError && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faImageLandscape, style: {
                margin: "auto",
                fontSize: "38px",
                color: "var(--lightgray-color)",
            } })),
        !isError && (react_1.default.createElement("img", { style: {
                margin: "auto",
            }, src: src, onLoad: handleLoad, onError: handleError, className: Presentations_module_css_1.default.thumb_image }))));
});
ImageFieldWithPlaceholder.displayName = "ImageFieldWithPlaceholder";
var PresentationsListView = function (_a) {
    var presentationType = _a.presentationType, presentationGroups = _a.presentationGroups, refreshPresentationGroups = _a.refreshPresentationGroups, permissions = _a.permissions;
    var route = (0, useRoute_1.default)();
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _b = (0, react_2.useState)(""), resourceName = _b[0], setResourceName = _b[1];
    var _c = (0, react_2.useState)(null), currentGroupId = _c[0], setCurrentGroupId = _c[1];
    var _d = (0, react_2.useState)(false), resourceAccessModalShown = _d[0], setResourceAccessModalShown = _d[1];
    var _e = (0, react_2.useState)(null), currentPresentationId = _e[0], setCurrentPresentationId = _e[1];
    var _f = (0, react_2.useState)(null), type = _f[0], setType = _f[1];
    var closeResourceAccessModal = function () { return setResourceAccessModalShown(false); };
    var hasPermission = (0, userPermissions_1.usePermissions)().hasPermission;
    var filters = [react_1.default.createElement(react_admin_1.SearchInput, { source: "title", alwaysOn: true, key: "queryFilter", placeholder: t("Search") })];
    var refresh = (0, react_admin_1.useRefresh)();
    var logger = q_play_core_1.logManager.getLogger();
    var _g = (0, react_2.useState)({ msg: "", players_and_presentation_details: [] }), deletePresentationErrorModalData = _g[0], setDeletePresentationErrorModalData = _g[1];
    var _h = (0, react_2.useState)(false), presentationDetachingError = _h[0], setPresentationDetachingError = _h[1];
    var _j = (0, react_2.useState)(false), isDeletePresentationErrorModalShown = _j[0], setDeletePresentationErrorModalShown = _j[1];
    var openResourceAccessModal = function (resourceId, resourceName, type) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setType(type);
            setResourceName(resourceName);
            setResourceAccessModalShown(true);
            if (type === "Group") {
                setCurrentGroupId(resourceId);
            }
            else if (type === "Resource") {
                setCurrentPresentationId(resourceId);
            }
            return [2 /*return*/];
        });
    }); };
    var handleGroupChange = function (groupId, groupName) {
        setCurrentGroupId(groupId);
        setResourceName(groupName);
        refresh();
    };
    var deleteSinglePresentation = function (presentationId) {
        if (presentationId === void 0) { presentationId = currentPresentationId; }
        return __awaiter(void 0, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ApiManager_1.default.deletePresentations(presentationId).then(function (res) {
                                var _a;
                                if (res.data.error) {
                                    var errorData = { msg: res.data.error };
                                    setDeletePresentationErrorModalShown(true);
                                    if ((_a = res.data.data) === null || _a === void 0 ? void 0 : _a.players_and_presentation_details) {
                                        errorData.players_and_presentation_details = res.data.data.players_and_presentation_details.map(function (detail) {
                                            if (!detail.resource_type) {
                                                detail.resource_type = types_2.ResourceType.PRESENTATION;
                                            }
                                            return detail;
                                        });
                                    }
                                    setCurrentPresentationId(presentationId);
                                    setDeletePresentationErrorModalData(errorData);
                                }
                                else {
                                    refresh();
                                    setDeletePresentationErrorModalShown(false);
                                    setCurrentPresentationId(null);
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        logger.error("Failed to delete presentation:", error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var detachPresentationFromPlayer = function (playerId, presentationVersionId) {
        var response = ApiManager_1.default.deletePlayerPresentation(presentationVersionId, playerId);
        response.then(function () {
            setDeletePresentationErrorModalData(function (data) {
                return {
                    msg: data.msg,
                    players_and_presentation_details: data.players_and_presentation_details.filter(function (d) { return d.primary_resource_id !== playerId; })
                };
            });
            setPresentationDetachingError(false);
        }).catch(function () {
            setPresentationDetachingError(true);
        });
    };
    var mapPresentationTypeToResourceType = function (presentationType) {
        switch (presentationType) {
            case types_1.PresentationType.PRESENTATION:
                return types_2.ResourceType.PRESENTATION;
            case types_1.PresentationType.PLAYLIST:
                return types_2.ResourceType.PLAYLIST;
            default:
                throw new Error("Invalid PresentationType for ResourceType");
        }
    };
    var onClone = function (presentationId, resourceType) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ApiManager_1.default.clonePresentations(presentationId, resourceType).then(function () {
                        refresh();
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_admin_1.ListBase, { queryOptions: {
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
                refetchOnMount: true,
                refetchInterval: 1000 * 60
            } },
            react_1.default.createElement("div", { className: Presentations_module_css_1.default.searchbar_container },
                react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaSearchInputTheme },
                    react_1.default.createElement(react_admin_1.FilterForm, { filters: filters })),
                react_1.default.createElement(q_play_components_1.Button, { variant: "empty", size: "small", className: "".concat(Presentations_module_css_1.default.filter_button, " d-flex align-items-center justify-content-center") },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faBarsFilter, style: { fontSize: "28px" }, color: "var(--info-color)" }))),
            react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaDatagridTheme },
                react_1.default.createElement(react_admin_1.Datagrid, { sx: __assign(__assign({}, RAStyles_1.RaDataGridSx), { "& .RaDatagrid-headerCell:nth-of-type(2)": {
                            width: "47px !important",
                        } }), hover: false, rowClick: function (_id, _resource, record) {
                        var resourceType = types_2.ResourceType[presentationType].toLowerCase() + "s";
                        if (hasPermission(__spreadArray(__spreadArray([], permissions.write, true), permissions.manage, true), record.presentation_id, resourceType)) {
                            var link = (react_1.default.createElement(inertia_react_1.InertiaLink, { href: route("editor/".concat(presentationType.toLowerCase()), record.presentation_id), id: "editorPresentationLink" }));
                            (0, react_dom_1.render)(link, document.getElementById("editorInertiaLink"));
                            document.getElementById("editorPresentationLink").click();
                        }
                        return null;
                    } },
                    react_1.default.createElement(react_admin_1.TextField, { label: "ID", source: "presentation_id" }),
                    react_1.default.createElement(react_admin_1.TextField, { source: "title", label: t("Title") }),
                    react_1.default.createElement(react_admin_1.WrapperField, { label: t("Group") },
                        react_1.default.createElement(SelectInputPresentationGroup, { groups: presentationGroups, onGroupsUpdated: refreshPresentationGroups, onGroupChange: handleGroupChange, type: presentationType, permissions: permissions })),
                    react_1.default.createElement(react_admin_1.WrapperField, { label: "Thumbnail" },
                        react_1.default.createElement("div", { style: {
                                width: "75px",
                                float: "left",
                                display: "flex",
                            } },
                            react_1.default.createElement(ImageFieldWithPlaceholder, { source: "thumbnail_url" }))),
                    react_1.default.createElement(ColoredStatusField, { t: t, label: "Status" }),
                    react_1.default.createElement(react_admin_1.FunctionField, { render: function (record) { return (react_1.default.createElement(AccessControl_1.default, { resourceType: "".concat(types_2.ResourceType[presentationType].toLowerCase(), "s"), optionalPermissions: __spreadArray(__spreadArray(__spreadArray([], permissions.write, true), permissions.manage, true), ["edit-user-management"], false) },
                            react_1.default.createElement(MeatballMenu_1.default, { onEdit: function () {
                                    var resourceType = types_2.ResourceType[presentationType].toLowerCase() + "s";
                                    if (hasPermission(__spreadArray(__spreadArray([], permissions.write, true), permissions.manage, true), record.presentation_id, resourceType)) {
                                        var link = (react_1.default.createElement(inertia_react_1.InertiaLink, { href: route("editor/".concat(presentationType.toLowerCase()), record.presentation_id), id: "editorPresentationLink" }));
                                        (0, react_dom_1.render)(link, document.getElementById("editorInertiaLink"));
                                        document.getElementById("editorPresentationLink").click();
                                    }
                                }, onDuplicate: function () { return onClone(record.presentation_id, record.type); }, onDelete: function () { return deleteSinglePresentation(record.presentation_id); }, onManageResourceAccess: function (id, name) { return openResourceAccessModal(id, name, "Resource"); }, onManageGroupAccess: function (id, name) { return openResourceAccessModal(id, name, "Group"); }, resourceId: currentPresentationId, type: type, resourceType: mapPresentationTypeToResourceType(presentationType) }))); } }))),
            react_1.default.createElement(Pagination_1.default, null)),
        react_1.default.createElement(ResourceAccessModal_1.default, { isShown: resourceAccessModalShown, onClose: closeResourceAccessModal, resourceType: types_2.ResourceType[presentationType], type: type, resourceName: resourceName, groupId: currentGroupId, resourceId: currentPresentationId }),
        react_1.default.createElement(ResourceDeleteErrorModal_1.default, { dataCy: "deletePresentationErrorModal", headerText: t("Unsuccessful deletion of presentation"), isShown: isDeletePresentationErrorModalShown, onClose: function () {
                setDeletePresentationErrorModalData({ msg: "", players_and_presentation_details: [] });
                setDeletePresentationErrorModalShown(false);
                setPresentationDetachingError(false);
            }, deleteResourceMethod: deleteSinglePresentation, detachResourceMethod: detachPresentationFromPlayer, resourceId: currentPresentationId, message: deletePresentationErrorModalData.msg, data: deletePresentationErrorModalData.players_and_presentation_details, resourceDetachError: presentationDetachingError, subTitleText: t("Deleting presentation was unsuccessful"), resourceAttachedToText: t("The presentation is attached to players"), tooltipText: function (resourceType) { return t("Detach ".concat(resourceType.toLowerCase(), " from this player")); }, detachErrorTest: t("Error detaching presentation") })));
};
exports.default = PresentationsListView;
